<template>
  <v-row>
    <v-col>
      <v-card class="elevation-2 mx-2 mt-12">
        <v-card-title>
          <v-layout>
            <v-flex xs12>
              <v-card
                dark
                raised
                class="elevation-5 px-3 py-4 mt-n12 title font-weight-light"
                color="secondary"
                >Мои данные</v-card
              >
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text class="mt-2">
          <v-row>
            <v-col>
              <v-row>
                <p class="px-2">
                  Количество дней отсрочки:
                  <span class="font-weight-bold">{{ creditDays }}</span>
                </p>
              </v-row>
              <v-row v-for="(item, i) in contracts" :key="i">
                <p class="px-2">
                  "{{ item.contractType }}" договор:
                  <span class="font-weight-bold">{{ item.name }}</span> от
                  <span class="font-weight-bold">{{ item.start | date }}</span>
                </p>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    contracts: Array,
    creditDays: Number,
  },
  computed: {},
  methods: {},
  data: () => ({}),
  mounted: function () {},
};
</script>
